import React from 'react';

import Grid from '@material-ui/core/Grid';
import DonutLarge from '@material-ui/icons/DonutLarge';
import styled from 'styled-components';
import DashboardCard from './components/DashboardCard';
import { getDemandDashboardData } from 'Actions/initActions';
import connect from 'react-redux/es/connect/connect';

const NoTicketsDashboard = styled.div`
  display: flex;
  align-content: center;
`;
const NoTicketsH2 = styled.h2`
  font-weight: bold;
  margin: 0 0 5px 0;
`;
const DonutLargeCustom = styled(DonutLarge)`
  font-size: 50px;
  width: 40px;
  height: 40px;
  color: #999a9a;
  margin-right: 20px;
`;
const NoTicketsP = styled.p`
  font-family: Times, 'Times New Roman', Times32;
  font-size: 12px;
  line-height: 13px;
  margin: 0;
  color: #62727b;
`;

const lineColors = [
  '#ffca28',
  '#62727b',
  '#c79a00',
  '#999a9a',
  '#F44336',
  '#37474f',
  '#37994f',
];

class HomeDashboard extends React.Component {
  componentDidMount() {
    this.props.getDashboardData();
  }

  renderDashboard = () => {
    if (this.props.dashboardData && this.props.dashboardData.length > 0) {
      return (
        <Grid
          container
          className="tickets-dashboard"
          alignItems={'center'}
          justify={'flex-start'}
          spacing={16}
        >
          {this.props.dashboardData.map((dashboardItem, index) => (
            <Grid item xl={4} lg={4} md={6} xs={12} key={dashboardItem.key}>
              <DashboardCard
                title={dashboardItem.title}
                count={dashboardItem.count}
                color={lineColors[index] ? lineColors[index] : '#fff'}
              />
            </Grid>
          ))}
        </Grid>
      );
    } else {
      return (
        <NoTicketsDashboard>
          <DonutLargeCustom />
          <div>
            <NoTicketsH2>Not enough data for statistic</NoTicketsH2>
            <NoTicketsP>
              0 New Luminaires, 0 Updated Luminaires, 0 Luminaires in total, 0
              Searches and 0 Items in 0 Projects
            </NoTicketsP>
          </div>
        </NoTicketsDashboard>
      );
    }
  };

  render() {
    return (
      // Page with tickets
      <React.Fragment>{this.renderDashboard()}</React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getDashboardData: () => {
    dispatch(getDemandDashboardData());
  },
});
const mapStateToProps = store => {
  return {
    dashboardData: store.initialData.demandDashboardData,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeDashboard);
